import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["matters"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      neosSyncPlansList: build.query<
        NeosSyncPlansListApiResponse,
        NeosSyncPlansListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/neos-sync/plans/`,
        }),
        providesTags: ["matters"],
      }),
      neosSyncActionUpdateFilename: build.mutation<
        NeosSyncActionUpdateFilenameApiResponse,
        NeosSyncActionUpdateFilenameApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/neos-sync/plans/${queryArg.planId}/actions/${queryArg.actionId}/filename/`,
          method: "PATCH",
          body: queryArg.patchedUpdateActionFilenameSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      neosSyncActionUpdateNoteContent: build.mutation<
        NeosSyncActionUpdateNoteContentApiResponse,
        NeosSyncActionUpdateNoteContentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/neos-sync/plans/${queryArg.planId}/actions/${queryArg.actionId}/note-content/`,
          method: "PATCH",
          body: queryArg.patchedUpdateActionNoteContentSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      neosSyncActionUpdateStatus: build.mutation<
        NeosSyncActionUpdateStatusApiResponse,
        NeosSyncActionUpdateStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/neos-sync/plans/${queryArg.planId}/actions/${queryArg.actionId}/status/`,
          method: "PATCH",
          body: queryArg.patchedUpdateActionStatusSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      neosSyncPlansTrigger: build.mutation<
        NeosSyncPlansTriggerApiResponse,
        NeosSyncPlansTriggerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/neos-sync/plans/trigger/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type NeosSyncPlansListApiResponse =
  /** status 200  */ NeosSyncPlanListSchema[];
export type NeosSyncPlansListApiArg = {
  matterId: string;
};
export type NeosSyncActionUpdateFilenameApiResponse =
  /** status 200  */ RootModelAnnotatedUnionNeosCreateBlobActionSchemaNeosCreateNeosDocumentActionSchemaNeosCreateNoteActionSchemaFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorActionType;
export type NeosSyncActionUpdateFilenameApiArg = {
  actionId: string;
  matterId: string;
  planId: string;
  patchedUpdateActionFilenameSchema: UpdateActionFilenameSchema;
};
export type NeosSyncActionUpdateNoteContentApiResponse =
  /** status 200  */ RootModelAnnotatedUnionNeosCreateBlobActionSchemaNeosCreateNeosDocumentActionSchemaNeosCreateNoteActionSchemaFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorActionType;
export type NeosSyncActionUpdateNoteContentApiArg = {
  actionId: string;
  matterId: string;
  planId: string;
  patchedUpdateActionNoteContentSchema: UpdateActionNoteContentSchema;
};
export type NeosSyncActionUpdateStatusApiResponse =
  /** status 200  */ RootModelAnnotatedUnionNeosCreateBlobActionSchemaNeosCreateNeosDocumentActionSchemaNeosCreateNoteActionSchemaFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorActionType;
export type NeosSyncActionUpdateStatusApiArg = {
  actionId: string;
  matterId: string;
  planId: string;
  patchedUpdateActionStatusSchema: UpdateActionStatusSchema;
};
export type NeosSyncPlansTriggerApiResponse = /** status 202  */ {
  workflow_id?: string;
};
export type NeosSyncPlansTriggerApiArg = {
  matterId: string;
};
export type NeosSyncActionStatus =
  | "PENDING"
  | "AWAITING_APPROVAL"
  | "APPROVED"
  | "REJECTED"
  | "EXECUTING"
  | "COMPLETED"
  | "FAILED";
export type NeosSyncApprovalTypes = "AUTO_APPROVE" | "MANUAL_APPROVE";
export type NeosCreateBlobActionSchema = {
  id: string | string;
  plan_id: string | string;
  status: NeosSyncActionStatus;
  approval_type: NeosSyncApprovalTypes;
  approved_by_id: (string | string) | null;
  approved_at: string | null;
  executed_at: string | null;
  completed_at: string | null;
  error_message: string | null;
  created_at: string;
  modified_at: string;
  action_type?: "CREATE_BLOB";
  neos_document_id: string | string;
  file_name: string;
};
export type NeosCreateNeosDocumentActionSchema = {
  id: string | string;
  plan_id: string | string;
  status: NeosSyncActionStatus;
  approval_type: NeosSyncApprovalTypes;
  approved_by_id: (string | string) | null;
  approved_at: string | null;
  executed_at: string | null;
  completed_at: string | null;
  error_message: string | null;
  created_at: string;
  modified_at: string;
  action_type?: "CREATE_NEOS_DOCUMENT";
  blob_id: string | string;
  file_name: string;
  suggested_name: string;
};
export type NeosCreateNoteActionSchema = {
  id: string | string;
  plan_id: string | string;
  status: NeosSyncActionStatus;
  approval_type: NeosSyncApprovalTypes;
  approved_by_id: (string | string) | null;
  approved_at: string | null;
  executed_at: string | null;
  completed_at: string | null;
  error_message: string | null;
  created_at: string;
  modified_at: string;
  action_type?: "CREATE_NEOS_NOTE";
  event_update_item_id: string | string;
  staff_note_id: (string | string) | null;
  task_update_id: (string | string) | null;
  subject: string | null;
  body: string;
};
export type NeosSyncPlanListSchema = {
  id: string | string;
  matter_id: string | string;
  neos_case_id: string | string;
  workflow_id: string;
  status: string;
  failure_reason: string | null;
  actions?: (
    | ({
        action_type: "CREATE_BLOB";
      } & NeosCreateBlobActionSchema)
    | ({
        action_type: "CREATE_NEOS_DOCUMENT";
      } & NeosCreateNeosDocumentActionSchema)
    | ({
        action_type: "CREATE_NEOS_NOTE";
      } & NeosCreateNoteActionSchema)
  )[];
  created_at: string;
  modified_at: string;
};
export type RootModelAnnotatedUnionNeosCreateBlobActionSchemaNeosCreateNeosDocumentActionSchemaNeosCreateNoteActionSchemaFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorActionType =

    | ({
        action_type: "CREATE_BLOB";
      } & NeosCreateBlobActionSchema)
    | ({
        action_type: "CREATE_NEOS_DOCUMENT";
      } & NeosCreateNeosDocumentActionSchema)
    | ({
        action_type: "CREATE_NEOS_NOTE";
      } & NeosCreateNoteActionSchema);
export type UpdateActionFilenameSchema = {
  /** New filename to use when creating the document in Filevine */
  file_name: string;
};
export type UpdateActionNoteContentSchema = {
  /** Optional subject line for the note */
  subject?: string | null;
  /** HTML content of the note to be created in Neos */
  body: string;
};
export type FilevineSyncActionStatus =
  | "PENDING"
  | "AWAITING_APPROVAL"
  | "APPROVED"
  | "REJECTED"
  | "EXECUTING"
  | "COMPLETED"
  | "FAILED";
export type UpdateActionStatusSchema = {
  /** New status for the action. Must be a valid transition from current status. */
  status: FilevineSyncActionStatus;
};
export const {
  useNeosSyncPlansListQuery,
  useNeosSyncActionUpdateFilenameMutation,
  useNeosSyncActionUpdateNoteContentMutation,
  useNeosSyncActionUpdateStatusMutation,
  useNeosSyncPlansTriggerMutation,
} = injectedRtkApi;
